<div class="card-box">
  <div class="name-section" [matTooltip]="isTaxonomyNameTruncated() ? taxonomy.taxonomy_name : ''">
    <span #taxonomyName>
      {{ taxonomy.taxonomy_name }}
    </span>
    <!-- Tag division -->
    <div class="tag-container" [ngClass]="getTagClass()">
      <span>{{ getTagText() }}</span>
    </div>
  </div>
  <div class="taxonomy-meta">
    <span>Taxonomy Owner: {{taxonomy.taxonomy_owner_name}}</span>
  </div>

  <div class="description-section"
    [matTooltip]="isTaxonomyDescriptionTruncated() ? (taxonomy.taxonomy_description || '-') : ''">
    <span #taxonomyDescription>
      {{ taxonomy.taxonomy_description || '-' }}
    </span>
  </div>

  <div class="action-section">
    <button class="btn-view"
      (click)="handleViewTaxonomy($event, taxonomy.taxonomy_id, taxonomy.taxonomy_name, taxonomy.version_history_details, taxonomy.version_history_details[0])">
      <span>View</span>
      <img src="../../../../assets/icons/btn-arrow.svg" alt="arrow">
    </button>
    <button class="btn-configure" (click)="pressConfigureBtn($event, taxonomy.taxonomy_id)">
      <span>Configure</span>
    </button>
  </div>
</div>
